import { FormattedMessage } from "react-intl";
import OwTitle from "../../shared/OwTitle/OwTitle";
import { OwIconButton } from "../../shared/OwIconButton/OwIconButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import React from "react";
import styled from "styled-components";

type Props = {
    systemMessages: any;
    removeWidget?: () => void;
    inEditor?: boolean;
};

export const SystemMessagesWidget = (props: Props) => {
    let systemMessageList: any = (
        <div className="d-flex text-center justify-content-center align-items-center flex-grow h-100 w-100">
            <FormattedMessage id="dashboard.no_system_messages" defaultMessage="No System Messages" description="No System Messages" />
        </div>
    );

    if (props.systemMessages.length) {
        systemMessageList = props.systemMessages.map((msg: string, index: number) => {
            return <div key={index} className={"col-12"}>{msg}</div>;
        });
    }

    return (
        <WidgetContainer className={"SystemMessagesWidget widget h-100 d-flex flex-column justify-content-start"}>
            {props.inEditor ? (
                <div>
                    <div className={"w-100"}>
                        <div>
                            <OwIconButton
                                iconClass={"fas fa-trash-alt"}
                                iconColorClass={"text-danger"}
                                fn={() => {
                                    props.removeWidget!();
                                }}
                            />
                        </div>
                        <div>
                            <OwLabel title={"system_messages"} />
                        </div>
                    </div>
                </div>
            ) : (
                <>
                    <OwTitle tag={"h4"} title={"dashboard.system_messages"} />
                    {systemMessageList}
                </>
            )}
        </WidgetContainer>
    );
};

const WidgetContainer = styled.div`
    padding: 0.5rem;
    justify-content: start !important;
    align-items: start !important;
    height: 100%;

    .position-relative {
        width: 100%;
    }
`;
